import React from 'react';
import {Link} from 'react-router-dom'
import PageWrapper from "./PageWrapper"
import { Container } from "@mui/material"

const NotFound = () => {
  return (
    <PageWrapper>
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          textAlign: "center",
          marginTop: "40px",
        }}
      >
        {/* 404 - Page not found */}
        <h1>404</h1>
        <h3>Oops! Page not found.</h3>
        <p>The page you're looking for doesn't exist.</p>
        <Link to="/" className="btn-eight">
          Back to home
        </Link>
        <img src="/images/assets/ils_21.svg" alt="" className="m-auto" />
        <img
          src="images/shape/shape_49.svg"
          alt=""
          className="shapes shape-one w-100"
        />
      </Container>
    </PageWrapper>
  )
}

export default NotFound